import { apiInstances } from '../../../../libs';

const { post } = apiInstances.orderInstance;

export default async function confirmReturnedToPickupPoint({
  id_order,
  ...payload
}) {
  return await post(
    `/clouders/orders/${id_order}/deliver-to-pickup-point`,
    payload
  );
}
